<template>
<section class="cid-qTkAaeaxX5" id="footer1-2">
    <div class="container">
        <div class="media-container-row content text-white">
            <div class="col-12 col-md-3">
                <div class="media-wrap">
                    <a href="/">
                        <img src="/assets/images/logo.png" alt="go4pro.org">
                    </a>
                </div>
            </div>
            <div class="col-12 col-md-3 mbr-fonts-style display-7">
                <h5 class="pb-3">
                    成员分布地
                </h5>
                <p class="mbr-text">
                    苏州，上海，杭州，南京，北京，深圳，德累斯顿
                </p>
            </div>
            <div class="col-12 col-md-3 mbr-fonts-style display-7">
                <h5 class="pb-3">
                    联系方法
                </h5>
                <p class="mbr-text">
                    Email: <a href="mailto:taylor.ren@gmail.com">taylor.ren@gmail.com</a>
                </p>
            </div>
            <div class="col-12 col-md-3 mbr-fonts-style display-7">
                <h5 class="pb-3">
                    技术框架
                </h5>
                <p class="mbr-text">
                    <a class="text-primary" href="https://nodejs.org/">Node.js</a><br/>
                    <a class="text-primary" href="https://vuejs.org/">Vue.js</a><br/>
                    站点UI设计通过<a class="text-primary" href="https://mobirise.com/">Mobirise</a>辅助设计
                    API开发为<a href="https://www.slimframework.com/">Slim</a>框架
                </p>
            </div>
        </div>
        <div class="footer-lower">
            <div class="media-container-row">
                <div class="col-sm-12">
                    <hr>
                </div>
            </div>
            <div class="media-container-row mbr-white">
                <div class="col-sm-6 copyright">
                    <p class="mbr-text mbr-fonts-style display-7">
                        © Copyright 2009 - {{year}}, <a href="/">Go4Pro.org</a> - All Rights Reserved
                    </p>
                </div>
                
            </div>
        </div>
    </div>
</section>

</template>
<script>
export default {
    name: "Footer",
    data: function () {
        return {
            year: new Date().getFullYear(),
        }
    }
}
</script>